import { render, staticRenderFns } from "./delete-event.vue?vue&type=template&id=051de42b&scoped=true"
import script from "./delete-event.vue?vue&type=script&lang=js"
export * from "./delete-event.vue?vue&type=script&lang=js"
import style0 from "./delete-event.vue?vue&type=style&index=0&id=051de42b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051de42b",
  null
  
)

export default component.exports